import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { ExclamationCircleFilled } from '@ant-design/icons';
import { Modal, } from 'antd';
import { onDeleteLearingGroup, onDeleteManyStudents, onGetAllAlumsByGroups } from "../../../api";
import { CustomTableUsers } from "./CustomTableUsers";
import { icons } from "../../../assets";
import { message } from "antd";

const { confirm } = Modal;
export const MainContentUsersTable = ({ dateRange, hasFilter }) => {
    const { groups } = useSelector(state => state.vrlSlice)
    const [usersByGroups, setusersByGroups] = useState([])
    const [usesToDelete, setUsesToDelete] = useState([])
    useEffect(() => {
        setusersByGroups([])
        const getUsers = async () => {
            setusersByGroups(await onGetAllAlumsByGroups(groups))
        }
        getUsers()
        // eslint-disable-next-line
    }, [groups])

    const onDeleteUsers = async () => {
        if (usesToDelete.length <= 0) {
            message.info("Selecciona al menos un alumno")
            return
        }
        confirm({
            title: '¿Estás seguro de que deseas eliminar a los alumnos?',
            icon: <ExclamationCircleFilled />,
            content: '',
            async onOk() {
                const result = await onDeleteManyStudents(usesToDelete)
                if (result.status === 0) {
                    message.success("Alumnos eliminados")
                    setusersByGroups([])
                    setusersByGroups(await onGetAllAlumsByGroups(groups))
                    setUsesToDelete([])
                }
                else {
                    message.error("Error a eliminar uno o varios alumnos")
                }
            },
            onCancel() {
                console.log('Cancelar');
            },
        });

    }

    const onDeleteGroup = async (grup) => {
        confirm({
            title: '¿Estás seguro de que deseas eliminar el grupo?',
            icon: <ExclamationCircleFilled />,
            content: '',
            async onOk() {
                const result = await onDeleteLearingGroup(grup.group_id)
                if(result.status > 0) {
                    message.error("Error a eliminar el grupo")
                    return
                }

                message.success("Grupo eliminado")
                const newGroupsUpdate = groups.filter((f) => f._id !== grup.group_id)
                setusersByGroups([])
                setusersByGroups(await onGetAllAlumsByGroups(newGroupsUpdate))

            },
            onCancel() {
                console.log('Cancelar');
            },
        });

    }


    return (
        <div className="h-full p-6 overflow-y-auto">
            <div className="flex flex-wrap gap-4 ">
                {usersByGroups &&
                    usersByGroups.map((grup, x) => {
                        return <div key={x} className="bg-[#F2F2F2] h-[448px] w-[448px] ">
                            <div className="w-full h-16 bg-[#E6E6E6] flex justify-between items-center px-2">
                                <div>
                                    <p className="text-sm font-bold text-black">{grup.group} </p>
                                </div>
                                <div className=" flex gap-4">
                                    {x > 0 && (
                                        <div onClick={() => onDeleteGroup(grup)} className="bg-686868 bg-opacity-25 hover:bg-opacity-40 px-2 py-2 rounded-lg cursor-pointer">
                                            <span>Borrar grupo</span>
                                        </div>
                                    )}
                                    <img
                                        onClick={() => onDeleteUsers()}
                                        src={usesToDelete.length <= 0 ? icons.trashIcon : icons.thasbalckicon} className="w-4 cursor-pointer " alt="" />
                                </div>
                            </div>
                            <div className="overflow-y-auto h-[384px] shadow-md">
                                <CustomTableUsers key={x} onDeleteUsers={setUsesToDelete} dataTable={grup.students}></CustomTableUsers>
                            </div>
                        </div>

                    })
                }
            </div>
        </div>
    );
};
